import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	isAccountTabMenu: true,
}

const accountSlice = createSlice({
	name: 'account',
	initialState,
	reducers: {
		setIsAccountTabMenu(account, { payload }) {
			return { ...account, isAccountTabMenu: payload }
		},
	},
})

export const { setIsAccountTabMenu } = accountSlice.actions

export default accountSlice.reducer
